export const EnumBoardType = {
  BANNER_CHAT: "BANNER_CHAT",
  BANNER_INQUIRY: "BANNER_INQUIRY",
  ADMIN_TASK: "ADMIN_TASK",
  ADMIN_BOARD: "ADMIN_BOARD",
  DEV_BOARD: "DEV_BOARD",
  EMERGENCY_NOTICE: "EMERGENCY_NOTICE",
  GENERAL_NOTICE: "GENERAL_NOTICE",
  AD_INQUIRY: "AD_INQUIRY",
  TRAVEL_INFO: "TRAVEL_INFO",
  HELP_BOARD: "HELP_BOARD",
  SERVICE_CENTER: "SERVICE_CENTER",
  IMPROVEMENT_REQUEST: "IMPROVEMENT_REQUEST",
  BUG_REPORT: "BUG_REPORT",
  CUSTOMER_INQUIRY: "CUSTOMER_INQUIRY",
} as const;
